import { Injectable } from '@angular/core';
import { AlertController, ToastController } from 'ionic-angular';
import { TOAST_DURATION } from './app-variables';
import { SplashScreen } from '@ionic-native/splash-screen';


@Injectable()
export class AlertProvider {

  canShowAlert: boolean = true;
  canShowToast: boolean = true;

  constructor(private alertCtrl: AlertController, private toastCtrl: ToastController, private splashScreen: SplashScreen) {
  }

  showAlert(title, message, buttons, enableBackdropDismiss, cssClass, restart?) {
    if(this.canShowAlert) {
      this.canShowAlert = false;
      let alert = this.alertCtrl.create({
        title: title,
        subTitle: message,
        buttons: buttons,
        enableBackdropDismiss : enableBackdropDismiss,
        cssClass: cssClass
      })
      alert.present();
      alert.onDidDismiss(() => {
        this.canShowAlert = true;
        if (restart) {
          this.splashScreen.show();  
          window.location.reload();
        }
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/myria/alert-provider.ts